module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-18-7340c3ed101cf94017deab5dcebf5865.svg";